import arrowStartSvg from "../../assets/images/icons/arrow_start.svg";
import arrowEndSvg from "../../assets/images/icons/arrow_end.svg";
import { formatDate } from "../../utils/common";

function ProductListPc({
  data,
  totalCount,
  currentPage,
  pageSize,
  onPageChange,
  resend,
  cancel,
}) {
  const totalPages = Math.ceil(totalCount / pageSize);

  const renderPagination = () => {
    const pages = [];
    const start = Math.floor((currentPage + 1 - 1) / 10) * 10 + 1;

    for (let i = start; i < start + 10 && i <= totalPages; i++) {
      pages.push(
        <li
          className={currentPage === i ? "on" : ""}
          key={i}
          onClick={() => onPageChange(i)}
        >
          {i}
        </li>
      );
    }

    return (
      <ul className="pagination">
        {start > 1 && (
          <li onClick={() => onPageChange(start - 1)}>
            <img src={arrowStartSvg} alt="" />
          </li>
        )}
        {pages}
        {start + 10 <= totalPages && (
          <li onClick={() => onPageChange(start + 10)}>
            <img src={arrowEndSvg} alt="" />
          </li>
        )}
      </ul>
    );
  };

  return (
    <div className="product-list-pc">
      <table>
        <thead>
          <tr>
            <th>쿠폰정보</th>
            <th>구매일자</th>
            <th>유형</th>
            <th>사용 유무</th>
            <th width="130px"></th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, i) => {
            return (
              <tr key={i}>
                <td>
                  <span>{item.serialNumber}</span>
                </td>
                <td>{formatDate(item.regDate)}</td>
                <td>{item.name}</td>
                <td>
                  {item.isUsed === "Y" ? (
                    <span className="success-use">사용완료</span>
                  ) : (
                    <span className="not-use">미사용</span>
                  )}
                </td>
                <td>
                  {item.isUsed === "N" && (
                    <button
                      className="resend"
                      onClick={() => {
                        resend(item.couponsSeq, item.phoneNumber);
                      }}
                    >
                      재발송
                    </button>
                  )}
                  {item.status === "completed" &&
                    item.paymentMethod !== "free" && (
                      <button
                        className="resend"
                        onClick={() => {
                          cancel(item.orderId, "고객 취소 신청");
                        }}
                      >
                        취소
                      </button>
                    )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {renderPagination()}
    </div>
  );
}

export default ProductListPc;
